import React from "react";

const BookingSection = () => {
  const containerStyle = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: "0 0.5rem", // Reduced padding on mobile
  };

  const sectionStyle = {
    padding: "2rem 0",
    backgroundColor: "white",
    margin: "0",
    borderRadius: "0",
  };

  const iframeStyle = {
    width: "100%",
    minWidth: "320px", // Ensure minimum width
    height: "800px",
    border: "none",
    borderRadius: "8px",
    boxShadow: "0 4px 20px rgba(8, 145, 178, 0.1)",
    // Allow horizontal scrolling if needed on very small screens
    overflowX: "auto",
  };

  // Media query simulation for mobile
  const isMobile = window.innerWidth <= 768;

  const responsiveContainerStyle = {
    ...containerStyle,
    padding: isMobile ? "0 0.25rem" : "0 1.5rem", // Much less padding on mobile
    maxWidth: isMobile ? "100%" : "1200px", // Full width on mobile
  };

  return (
    <div style={sectionStyle}>
      <div style={responsiveContainerStyle}>
        <iframe
          src="https://www.picktime.com/900proshop#services/service"
          style={iframeStyle}
          title="900 Pro Shop Services - Picktime Booking"
          allowFullScreen
          loading="lazy"
        />
      </div>
    </div>
  );
};

export default BookingSection;
